module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'fields',
        'autoComplete',
    ],

    config: {
        showCustomActionButton: true,
        showCustomActionButtonIcon: 'fi fi-advertise'
    },

    methods: {
        customAction(){
            const baseActionKey = `showSelect_employeeViaApplication`
            const actionKey = `${baseActionKey}_inEffect`
            return this.performAndStoreAction(
                actionKey,
                this.prepareAction(baseActionKey, undefined, {
                    decisionOrigin: {
                        type: 'selectEmployeeViaApplication',
                    }
                }),
                true
            )
        }
    },

    hooks: {
        async onDecision($element, options){
            let hideModalComponent = false

            let modalContentComponent
            if(options.decisionComponent.hasClass('base_modal_modal')) {
                hideModalComponent = options.decisionComponent
                modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
            }

            switch(options.decisionType){
                case 'submit':
                    const decisionOptions = (options || {}).decisionOptions || {}
                    const decisionOrigin = (options || {}).decisionOrigin || {}

                    if(decisionOrigin.type === 'selectEmployeeViaApplication'){
                        const attributes = (decisionOptions.entityData || {}).attributes || {}
                        const status = attributes.status
                        const entityID = decisionOptions.entityID

                        if(status === 'revoked'){
                            return await this.performAction(
                                this.prepareAction('message', undefined, {
                                    messageDisplay: {
                                        message: 'error:projects.projectTermJobs.notAbleToAssignEmployeeViaApplicationStatusRevoked'
                                    }
                                }, {
                                    statusControllerLoadingMessage: '',
                                    statusControllerSavingMessage:  ''
                                })
                            )
                        }

                        if(entityID){
                            this.chooseByValue(entityID)
                        }

                        if(options.decisionComponent){
                            options.decisionComponent.closest('base_modal_modal', modal => {
                                hideModalComponent = modal
                            })
                        }
                    }

                    // hide modal
                    if(hideModalComponent){
                        hideModalComponent.hide()
                    }
                    break;

                case 'cancel':
                default:
                    // hide modal
                    if(hideModalComponent){
                        hideModalComponent.hide()
                    }
                    break;
            }
        },
    },
}